import React, { Component } from 'react'
// libs
import ReactTooltip from 'react-tooltip'
// components
import { OldButton } from 'components/Button'
import Modal from 'components/ModalOld'
import AddClient from 'pages/Manager/Clients/List/AddEdit'
import InviteRecruiters from 'pages/Manager/InviteRecruiters'
import Menu from 'pages/NavBar/Menu'
import UserInfo from 'pages/NavBar/UserInfo'
import NotificationsMenu from 'pages/Notifications/Menu'
import ReceivePoints from 'pages/Recruiter/RecievedPoints'
// redux
import { notificationTypeSelector, NotificationTypeT } from 'domain/constants'
import { signOut, userSelector } from 'domain/env'
import { postClientPromiseCreator } from 'domain/manager/clients/actions'
import {
  notificationsAsViewed,
  notificationsSelector,
  unreadNotificationsCount
} from 'domain/notifications'
import { receivedPoints, rewardsViewPromiseCreator } from 'domain/recruiter/points'
import { receivedPointsSelector } from 'domain/recruiter/selectors'
import { connect } from 'react-redux'
import { compose, Dispatch } from 'redux'
import { ActionCreatorFunction, bindPromiseCreators, PromiseCreator } from 'redux-saga-routines'
// types
import { Classes } from 'jss'
import { NotificationsListType } from 'pages/Notifications/types'
import { ClientFormValues } from 'types/clientTypes'
import { ComposeType, ReceivedPointsType, UserType } from 'types/common'
import { StateInterface } from 'types/state'
// styles
import injectSheet from 'react-jss'
import { sheet } from './sheet'
// utils
import { Roles } from 'lib/roles'
// icons
import { ReactComponent as Notifications } from 'components/svg/Notifications.svg'
import MobileMenu from 'components/svgComponent/Menu'
import { textColors } from '../../style/colors'
import { SKILENT_VERSION } from '../../lib/variables'

interface Props {
  classes: Classes
  user: UserType
  signOut: () => void
  postClientPromiseCreator: PromiseCreator
  dispatch: Dispatch
  rewardsView: PromiseCreator
  points: ReceivedPointsType
  getReceivedPoints: ActionCreatorFunction
  countUnreadNotifications: number
  notifications: NotificationsListType
  notificationsTypes: NotificationTypeT
  notificationsAsViewed: (val: number[]) => void
  toggleSidebarMenu: () => void
}

interface State {
  openMenu: boolean
  isOpenModalInvite: boolean
  isOpenModalAddClient: boolean
  isOpenNotificationsMenu: boolean
  formError: string
}

class NavBar extends Component<Props, State> {
  wrapperRef: HTMLDivElement | null | undefined
  wrapperRefMenu: HTMLDivElement | null | undefined
  wrapperRefNotifications: HTMLDivElement | null | undefined
  wrapperRefNotificationsMenu: HTMLDivElement | null | undefined

  state = {
    openMenu: false,
    isOpenModalInvite: false,
    isOpenModalAddClient: false,
    isOpenNotificationsMenu: false,
    formError: ''
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (event: any) => {
    if (
      this.wrapperRef &&
      this.wrapperRefMenu &&
      !this.wrapperRef.contains(event.target) &&
      !this.wrapperRefMenu.contains(event.target) &&
      this.state.openMenu
    ) {
      this.openCloseMenu()
    }

    if (
      this.wrapperRefNotifications &&
      this.wrapperRefNotificationsMenu &&
      !this.wrapperRefNotifications.contains(event.target) &&
      !this.wrapperRefNotificationsMenu.contains(event.target) &&
      this.state.isOpenNotificationsMenu
    ) {
      this.toggleNotificationsMenu()
    }
  }

  setWrapperRef = (node: HTMLDivElement) => {
    this.wrapperRef = node
  }

  setWrapperRefMenu = (node: HTMLDivElement) => {
    this.wrapperRefMenu = node
  }

  setWrapperRefNotifications = (node: HTMLDivElement) => {
    this.wrapperRefNotifications = node
  }

  setWrapperRefNotificationsMenu = (node: HTMLDivElement) => {
    this.wrapperRefNotificationsMenu = node
  }

  openCloseMenu = () => {
    this.setState({ openMenu: !this.state.openMenu })
  }

  toggleNotificationsMenu = () => {
    if (!this.props.notifications || this.props.notifications.isEmpty()) return
    this.setState({ isOpenNotificationsMenu: !this.state.isOpenNotificationsMenu }, () => {
      ReactTooltip.rebuild()
      if (!this.state.isOpenNotificationsMenu && this.props.countUnreadNotifications > 0) {
        const { notifications } = this.props
        const asViewedArray =
          notifications && !notifications.isEmpty() && notifications.size > 7
            ? notifications.take(7)
            : notifications
        const indexArray = asViewedArray
          .filter(item => !item.get('viewedAt'))
          .map(item => item.get('id'))
          .toJS()
        if (indexArray && indexArray.length) {
          this.props.notificationsAsViewed(indexArray)
        }
      }
    })
  }

  toggleModalInvite = () => {
    this.setState({ isOpenModalInvite: !this.state.isOpenModalInvite })
  }

  rewardsViewPoints = (id: number) => {
    const promise = this.props.rewardsView(id, this.props.dispatch)
    promise.then(
      () => {
        this.setState({ formError: '' })
        this.props.getReceivedPoints()
      },
      failurePayload => {
        const errorText =
          failurePayload &&
          failurePayload.err &&
          failurePayload.err.response &&
          failurePayload.err.response.data &&
          ((failurePayload.err.response.data.errors &&
            failurePayload.err.response.data.errors.length > 0 &&
            failurePayload.err.response.data.errors[0].message) ||
            failurePayload.err.response.data.message)
        this.setState({
          formError: errorText || 'Something went wrong!'
        })
      }
    )
  }

  toggleModalAddClient = () => {
    this.setState({ isOpenModalAddClient: !this.state.isOpenModalAddClient })
  }

  addClient = (data: ClientFormValues) => {
    const promise = this.props.postClientPromiseCreator({ data }, this.props.dispatch)
    promise.then(
      () => {
        this.setState({ formError: '' })
        this.toggleModalAddClient()
      },
      failurePayload => {
        const errorText =
          failurePayload &&
          failurePayload.err &&
          failurePayload.err.response &&
          failurePayload.err.response.data &&
          ((failurePayload.err.response.data.errors &&
            failurePayload.err.response.data.errors.length > 0 &&
            failurePayload.err.response.data.errors[0].message) ||
            failurePayload.err.response.data.message)
        this.setState({
          formError: errorText || 'Something went wrong!'
        })
      }
    )
  }

  render() {
    const {
      classes,
      user,
      points,
      countUnreadNotifications,
      notifications,
      notificationsTypes,
      toggleSidebarMenu
    } = this.props
    const {
      openMenu,
      isOpenModalInvite,
      isOpenModalAddClient,
      formError,
      isOpenNotificationsMenu
    } = this.state
    const photo = user.get('avatar')
    const name = [user.get('firstName'), user.get('lastName')].join(' ')
    const role = Roles[user.get('role')]
    const versionLabel = SKILENT_VERSION ? `v${String(SKILENT_VERSION).replace(/^v/i, '')}` : ''

    return (
      <nav className={`${classes.root} gradient-blue`}>
        <MobileMenu className={classes.mobileMenu} onClick={toggleSidebarMenu} />

        {points && !points.isEmpty() && role === Roles.recruiter && (
          <Modal withIcon={true} hideClose={true}>
            <ReceivePoints
              toggleModal={this.rewardsViewPoints}
              receivedPoints={points}
              formError={formError}
            />
          </Modal>
        )}
        {isOpenModalInvite && (
          <Modal openCloseModal={this.toggleModalInvite}>
            <InviteRecruiters toggleModal={this.toggleModalInvite} />
          </Modal>
        )}
        {isOpenModalAddClient && (
          <Modal openCloseModal={this.toggleModalAddClient} isScroll={true}>
            <AddClient
              openCloseModal={this.toggleModalAddClient}
              isNewClient={true}
              onSubmit={this.addClient}
              formError={formError}
            />
          </Modal>
        )}
        <div className={classes.leftHeader}>
          <div className={classes.logoWrapper}>
            <img className={classes.logoImage} alt="logo" src="/skilentLogo.png" />
            {versionLabel && <span className={classes.logoVersion}>{versionLabel}</span>}
          </div>
          Skilent
        </div>

        <div className={classes.rightHeader}>
          <div className={classes.supportBtn}>
            <OldButton
              color={textColors.lightGray}
              isLink={true}
              to="/support"
              label="Support"
              authLink={true}
            />
          </div>
          {openMenu && (
            <Menu
              setWrapperRef={this.setWrapperRef}
              user={user}
              signOut={this.props.signOut}
              openCloseMenu={this.openCloseMenu}
              toggleModalInvite={this.toggleModalInvite}
              toggleModalAddClient={this.toggleModalAddClient}
            />
          )}
          {isOpenNotificationsMenu && (
            <NotificationsMenu
              setWrapperRef={this.setWrapperRefNotifications}
              notifications={notifications}
              notificationsTypes={notificationsTypes}
              countUnreadNotifications={countUnreadNotifications}
              toggleNotificationsMenu={this.toggleNotificationsMenu}
              role={user.get('role')}
            />
          )}
          <div
            className={`${classes.notifications} flex-center`}
            onClick={this.toggleNotificationsMenu}
            ref={this.setWrapperRefNotificationsMenu}
          >
            <Notifications height={25} width={25} />
            <div className={`${classes.circle} flex-center`}>
              {countUnreadNotifications > 99 ? '99+' : countUnreadNotifications}
            </div>
          </div>
          <div
            onClick={this.openCloseMenu}
            ref={this.setWrapperRefMenu}
            className={classes.clickArea}
          >
            <UserInfo
              openMenu={openMenu}
              role={role}
              photo={photo}
              name={name}
              isHideInfoOnXS={true}
            />
          </div>
        </div>
      </nav>
    )
  }
}

export default compose<ComposeType<Props, { toggleSidebarMenu: () => void }>>(
  connect(
    (state: StateInterface) => ({
      user: userSelector(state),
      points: receivedPointsSelector(state),
      countUnreadNotifications: unreadNotificationsCount(state),
      notifications: notificationsSelector(state),
      notificationsTypes: notificationTypeSelector(state)
    }),
    dispatch => ({
      ...bindPromiseCreators(
        {
          postClientPromiseCreator,
          rewardsView: rewardsViewPromiseCreator
        },
        dispatch
      ),
      signOut: () => dispatch(signOut()),
      notificationsAsViewed: (data: number[]) => dispatch(notificationsAsViewed(data)),
      getReceivedPoints: () => dispatch(receivedPoints()),
      dispatch
    })
  ),
  injectSheet(sheet)
)(NavBar)
